import { createContext } from 'react';

import { ActiveLicenses } from './active-licenses.interface';

export interface LicensesContextValue {
  /**
   * Active licenses that are fetched from the license service.
   * Undefined until they are fetched the first time.
   */
  activeOnline: ActiveLicenses | undefined;

  defaults: ActiveLicenses;

  /** Determines if the licenses have been fetched from the server at least once. */
  isOnline: boolean;
}

export const LicensesContext = createContext<LicensesContextValue>({
  activeOnline: undefined,
  defaults: {},
  isOnline: false,
});
